// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"06ae63b3","205":"41ea05c2","239":"1b6005e0","389":"21d9269a","453":"a2f99072","455":"f4b76a48","551":"bcf0791b","672":"cd3e7c85","842":"dff1048a"}[chunkId] + ".chunk.js";
};